import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { IBaseRequestParams } from '../../../../store/types/Request.types';

import { IMeetingResponse } from './meeting.types';

const prefix = 'RECIPIENT/MEETING';

export const changeWeek = createAction<{ to: string; from: string }>(`${prefix}/CHANGE_WEEK`);

export const meetingSlotsRequest = createAction<IBaseRequestParams>(`${prefix}/MEETING_SLOTS_REQUEST`);
export const meetingSlotsSuccess = createAction<IMeetingResponse>(`${prefix}/MEETING_SLOTS_SUCCESS`);
export const meetingSlotsFail = createAction<TLegacyErrors>(`${prefix}/MEETING_SLOTS_FAIL`);

export const resetMeetingSlots = createAction<void>(`${prefix}/RESET_MEETING_SLOTS`);
